<template>
  <div />
</template>
<script>
  import { get } from 'vuex-pathify'
  export default {
    name: 'BarionPixel',
    computed: {
      profile: get('auth/profile'),
    },
    watch: {
      profile: {
        handler () {
          // window.location.reload()
        },
        deep: true,
      },
    },
    created () {
      this.init()
      // console.log(window.barion_pixel_id)
    },
    methods: {
      init () {
        window.bp = null
        // Create BP element on the window
        window.bp = window.bp || function () {
          (window.bp.q = window.bp.q || []).push(arguments)
        }
        window.bp.l = 1 * new Date()

        // Insert a script tag on the top of the head to load bp.js
        const scriptElement = document.createElement('script')
        const firstScript = document.getElementsByTagName('script')[0]
        scriptElement.async = true
        scriptElement.src = 'https://pixel.barion.com/bp.js'
        firstScript.parentNode.insertBefore(scriptElement, firstScript)
        window.barion_pixel_id = this.profile.organization.barion_pixel_id
        window.bp('init', 'addBarionPixelId', window.barion_pixel_id)
      },
    },
  }
</script>
